export class DocumentoRelacionadoModel {    
    public idCFDI: number;
    public idCostoDetalle: number;
    public idTipoArchivo: number;
    public archivo: string;
    public fileContentBase64: string;
    public fileName: string;
    public fileExt: string;
    public fileArray: string;

    constructor() { }
}